import { joinWithOr } from "utils/formatUtility";

// The prompt to map one field of an either/or group, e.g. "Map either Percentage or Fraction"
export function describeEitherOrPrompt(fields: string[]): string {
  return `Map either ${joinWithOr(fields)}`;
}
